import { AxiosResponse } from 'axios'
import { format } from 'date-fns'
import { Contracts } from 'src/types/contracts'
import { ContractStatusCode } from 'src/types/contractStatus'
import { HikisariStatusCode } from 'src/types/hikisari'

import axios from '../../axios'

export const fetchContracts = async (
  agencyCode?: string,
  page?: number,
  keyword?: string,
  nameLike?: string,
  statuses?: ContractStatusCode[],
  selectedHikisariStatuses?: HikisariStatusCode[],
  startFirstContractDate?: Date,
  endFirstContractDate?: Date,
  startFirstPaymentDate?: Date,
  endFirstPaymentDate?: Date
): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: Contracts }>('/api/contracts', {
      params: {
        agencyCode: agencyCode,
        page: page,
        keyword: keyword ?? '',
        nameLike: nameLike ?? '',
        statuses: statuses ?? [],
        selectedHikisariStatuses: selectedHikisariStatuses ?? [],
        startFirstContractDate: startFirstContractDate
          ? format(new Date(startFirstContractDate), 'yyyy/MM/dd HH:mm')
          : null,
        endFirstContractDate: endFirstContractDate
          ? format(new Date(endFirstContractDate), 'yyyy/MM/dd HH:mm')
          : null,
        startFirstPaymentDate: startFirstPaymentDate
          ? format(new Date(startFirstPaymentDate), 'yyyy/MM/dd HH:mm')
          : null,
        endFirstPaymentDate: endFirstPaymentDate
          ? format(new Date(endFirstPaymentDate), 'yyyy/MM/dd HH:mm')
          : null,
      },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
